<div class="containerRas" cdkDropListGroup>
  <table
    *ngIf="option == 'Casos'"
    mat-table
    [dataSource]="dataSource"
    class="mat-elevation-z8"
  >
    <ng-container matColumnDef="gai">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-content first">
          <div class="header-child">Número</div>
        </div>
      </th>
      <td
        mat-cell
        class="pointerMouse"
        (click)="seeCase(element._id)"
        *matCellDef="let element"
      >
        {{ element.gai }}
      </td>
    </ng-container>

    <ng-container matColumnDef="caseType">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-content">
          <div class="header-child">Tipo de caso</div>
        </div>
      </th>
      <td
        mat-cell
        class="pointerMouse"
        (click)="seeCase(element._id)"
        *matCellDef="let element"
      >
        {{ element.caseType.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-content">
          <div class="header-child">Descripción</div>
        </div>
      </th>
      <td
        mat-cell
        class="pointerMouse"
        (click)="alert(element.gai, element.description)"
        *matCellDef="let element"
      >
        <div class="descriptionDiv">
          {{ element.description }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="assing">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-content">
          <div class="header-child">Responsable</div>
        </div>
      </th>
      <td
        mat-cell
        class="pointerMouse"
        (click)="seeCase(element._id)"
        *matCellDef="let element"
      >
        {{ element.assigned.fullname }}
      </td>
    </ng-container>

    <ng-container matColumnDef="lastModification">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-content">
          <div class="header-child">última modificación</div>
        </div>
      </th>
      <td
        mat-cell
        class="pointerMouse"
        (click)="seeCase(element._id)"
        *matCellDef="let element"
      >
        {{ element.updatedAt | date : "dd/MM/yyy" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-content last">
          <div class="header-child">Tipo</div>
        </div>
      </th>
      <td
        mat-cell
        class="pointerMouse"
        (click)="seeCase(element._id)"
        *matCellDef="let element"
      >
        <div class="type-caso">{{ option }}</div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <table
    *ngIf="option == 'Tareas'"
    mat-table
    [dataSource]="dataSource"
    class="mat-elevation-z8"
  >
    <ng-container matColumnDef="task">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-content first">
          <div class="header-child">Tarea</div>
        </div>
      </th>
      <td
        mat-cell
        class="pointerMouse"
        (click)="seeCase(element.case._id)"
        *matCellDef="let element"
      >
        {{ element.title }}
      </td>
    </ng-container>

    <ng-container matColumnDef="icase">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-content">
          <div class="header-child">Caso</div>
        </div>
      </th>
      <td
        mat-cell
        class="pointerMouse"
        (click)="seeCase(element.case._id)"
        *matCellDef="let element"
      >
        {{ element.case.gai }}
      </td>
    </ng-container>

    <ng-container matColumnDef="lastModification">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-content">
          <div class="header-child">última modificación</div>
        </div>
      </th>
      <td
        mat-cell
        class="pointerMouse"
        (click)="seeCase(element.case._id)"
        *matCellDef="let element"
      >
        {{ element.updatedAt | date : "dd/MM/yyy" }}
      </td>
    </ng-container>
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-content">
          <div class="header-child">Estado</div>
        </div>
      </th>
      <td
        mat-cell
        class="pointerMouse"
        (click)="seeCase(element.case._id)"
        *matCellDef="let element"
      >
        {{ returnState(element.status) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>
        <div class="header-content last">
          <div class="header-child">Tipo</div>
        </div>
      </th>
      <td
        mat-cell
        class="pointerMouse"
        (click)="seeCase(element.case._id)"
        *matCellDef="let element"
      >
        <div class="type-caso">{{ option }}</div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsTask"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsTask"></tr>
  </table>
</div>
